import { createSlice } from '@reduxjs/toolkit';
import { submitFAQProgram } from './Utils/FAQProgramUtils';

const initialState = {
    question: '',
    answer: '',
    is_show: "",
    isUpdate: false,
    id: '',
    isLoading: false,
};

const addFAQProgram = createSlice(
    {
        name: 'addFAQProgram',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(submitFAQProgram.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(submitFAQProgram.fulfilled, (state, action) => {
                    // Handle success state
                    state.isLoading = false;
                    console.log('Sukses:', action.payload);
                })
                .addCase(submitFAQProgram.rejected, (state, action) => {
                    // Handle error state
                    state.isLoading = false;
                    console.log(action.error.message, "error action")
                });
        }
    }
);


export const { setField, resetState } = addFAQProgram.actions;

export default addFAQProgram.reducer;